<template>

  <div class="selectable">

    <v-card v-bind:class="selectedClass">
      <v-img v-bind:src="option.url" v-bind:id="option.id" v-on:click="select"/>
    </v-card>

    <div v-if="order > 0" class="order">
      {{ order }}
    </div>

  </div>

</template>

<script>

export default {
  name: 'Option',
  
  props: {
    option: Object,
    counter: Number,
    selectable: Boolean
  },

  data: function() {
    return {
      selected: false,
      order: 0
    }
  },

  computed: {

    selectedClass: function() {
      if(this.selected){
        return "selected"
      } else {
        return ""
      }
    }

  },
  
  methods: {

    select: function() {

      // Do not select if not selectable
      if(!this.selectable) {
        return
      }

      if(this.selected){
        
        console.log("Todo")

        //// De-selection
        //const oldOrder = this.order
        //this.selected = false
        //this.order = 0

        //// Emit event
        //this.$emit("unselected", this.option.id, oldOrder)

      } else {

          // Select this option
          this.selected = true
          this.order = this.counter

          // Emit event
          this.$emit("selected", this.option.id)
      
      }

    }
  }
  
}

</script>

<style scoped>

.selected {
  margin: 6%;
}

.selectable {
  position: relative;
}

.order {
  border-radius: 50%;
  background: rgba(183,175,200,1);
  width: 1.5em;
  height: 1.5em;
  position: absolute;
  text-align: center;
  color: white;
  top: 0;
}

</style>
